// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"30849776","296":"d99d6531","404":"381822ab","629":"68b686ff","673":"31ba53ab","698":"7d5a1945","784":"0bf84863","830":"68ea4f8f"}[chunkId] + ".chunk.js";
};